import { isDenebEnabled } from '@/const/flags'
import { queryClient } from '@/lib/react-query'

import { userKeyFactory } from './key'
import {
  useMe as useAltairMe,
  type UseMeOptions as UseAltairMeOptions,
} from './me.altair'
import {
  useMe as useDenebMe,
  type UseMeOptions as UseDenebMeOptions,
} from './me.deneb'

export type UseMeOptions = UseAltairMeOptions | UseDenebMeOptions

export const useMe = isDenebEnabled ? useDenebMe : useAltairMe

export const invalidateUser = async () => {
  const key = userKeyFactory.me()
  await queryClient.invalidateQueries(key)
}

export const resetUser = async () => {
  const key = userKeyFactory.me()
  await queryClient.resetQueries(key)
}
